import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/ChapterDirectorPlaybookContent';

export default function ChapterDirectorPlaybook() {
  return <DocContent blocks={blocks} />;
}
